<template>
<div class="w-electricity-statistics">
  <div v-for="(data, index) in electricityStatisticsData" :key="index">
    <ElectricityBlock :blockData="data"></ElectricityBlock>
  </div>
</div>
</template>

<script>
import ElectricityBlock from './electricity-block.vue';
export default {
  props: {
    statisticsData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    ElectricityBlock
  },
  data() {
    return {
      electricityStatisticsData: []
    }
  },
  watch: {
    statisticsData(val) {
      this.electricityStatisticsData = val;
    }
  },
  methods: {},
  mounted() {
    this.electricityStatisticsData = this.statisticsData;
  }
}
</script>

<style lang="scss">
.w-electricity-statistics {
  width: 100%;
  // height: 100%;
  position: absolute;
  top: 27vh;
  left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/w-electricity-statistics.vue